import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Button,
	Typography,
	Grid,
	InputAdornment,
	FormHelperText
} from '@material-ui/core';
import SearchIcon from "@material-ui/icons/Search";

import {
	CloseOutlined as CloseIcon,
	FileCopy as CopyIcon,
} from '@material-ui/icons';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';
import Chip from '@material-ui/core/Chip';


import { MyPATIconButton, MyPATDialog } from '../../common';
import ContentData from '../types/ContentData';
import { UserData } from '../types/ContentData';
import contentService from '../services/contentService';
// import userService from '../services/userService';
import { usersList } from '../actions/userActions';

const styles = (theme: Theme) => createStyles({
	root: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	searchIcon: {
		fill: theme.palette.text.secondary,
		opacity: 0.5
	},
	formControl: {
		margin: theme.spacing.unit,
		minWidth: 120,
		width: '95%',
	},
	chips: {
		display: 'flex',
		flexWrap: 'wrap',
	},
	chip: {
		margin: theme.spacing.unit / 4,
	},
	noLabel: {
		marginTop: theme.spacing.unit * 3,
	},
	author: {
		margin: '30px auto 20px',
		display: 'block',
	},
	requiredHeading: {
		color: theme.palette.secondary.main,
	},
});


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250,
		},
	},
};


//@ts-ignore
interface Props extends WithStyles<typeof styles> {
	classes: any,
	contentList: ContentData[]
	isAuthorDialogOpen: boolean,
	onAuthorSelected: Function,
	users: UserData[]
	usersList: Function,
}
interface States {
	selectedUsers: any,
	search: string,
	searchedArray: any,

}

class ContentAuthorModal extends Component<Props, States> {
	state = {
		selectedUsers: [],
		search: "",
		searchedArray: []
		// users: [],
	};

	constructor(props: Props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
		this.handleSelectOpen = this.handleSelectOpen.bind(this);
		this.handleChangeMultiple = this.handleChangeMultiple.bind(this);
		this.onAuthorSelected = this.onAuthorSelected.bind(this);
	}

	componentWillReceiveProps(props: Props) {
		this.setState({ searchedArray: props.users })
	}


	componentDidMount() {
		this.props.usersList();
	}

	handleChange(event: any) {
		if (event.target.value) {
			let newValue = event.target.value.filter((al: any) => al != undefined)
			this.setState({ selectedUsers: newValue });
		}
	};
	handleSelectOpen(event: any) {
		const search: any = event.target.value.toLowerCase()
		// if(search && !(search instanceof Array)) {
		// 	this.state.search = search.toLowerCase()
		// }
		if (search.length > 0) {
			let searchedUsers = this.props.users.filter((user: UserData, key: any) => (this.props.users[key].fullName && this.props.users[key].fullName.toLowerCase().includes(search)) == true);
			this.setState({ searchedArray: searchedUsers })
		}
	}
	handleChangeMultiple(event: any) {
		const { options } = event.target;
		const value: any = [];
		for (let i = 0, l = options.length; i < l; i += 1) {
			if (options[i].selected) {
				value.push(options[i].value);
			}
		}
		this.setState({
			selectedUsers: value,
		});
	};

	onAuthorSelected(action: boolean) {
		if (this.state.selectedUsers.length > 0 && action) {
			this.props.onAuthorSelected(action, this.state.selectedUsers);
		} else if (!action) {
			this.props.onAuthorSelected(action, null);
		}
	}


	render() {
		const { classes, isAuthorDialogOpen, contentList, users } = this.props;
		const { search, searchedArray } = this.state;

		return (
			<div>
				<MyPATDialog
					dialogOpen={isAuthorDialogOpen}
					otherDialogProps={{
						fullWidth: true,
						maxWidth: 'sm',
					}}
					customDialogActions={
						<>
							<Button variant="contained" color="primary" onClick={() => { this.onAuthorSelected(true) }}>Save</Button>

							<Button
								color="primary"
								onClick={() => { this.onAuthorSelected(false) }}>
								Cancel
              </Button>
						</>
					}
				>
					<img src="/assets/img/mylibrary/author.png" className={classes.author} />
					<FormControl className={classes.formControl}>
						<InputLabel htmlFor="select-multiple-chip">Select authors<span className={classes.requiredHeading}>*</span></InputLabel>
						<Select
							style={{ width: '100%' }}
							multiple
							value={this.state.selectedUsers}
							//onClick={this.handleSelectOpen}
							onChange={this.handleChange}
							input={<Input id="select-multiple-chip" />}
							renderValue={(selected: any) => (
								<div className={classes.chips}>
									{selected.map((value: any, index: number) => (
										<Chip key={`value ${index}`} label={users.map((s: any) => (s._id == value ? s.fullName : ""))} className={classes.chip} />
									))}
								</div>
							)}
							MenuProps={MenuProps}
						>
							<div style={{ marginLeft: '10px' }}>
								<Input endAdornment={
									<InputAdornment position="end">
										<SearchIcon classes={{ root: classes.searchIcon }} />
									</InputAdornment>
								} onChange={this.handleSelectOpen} style={{ position: 'relative', width: '470px', fontFamily: 'Open Sans', fontSize: '18.9px' }}
									placeholder={"Search Authors*"}
									id="my-helper-text">
								</Input>
							</div>

							{
								this.state.searchedArray.map((user: UserData, index: number) => (
									<MenuItem key={`${user._id} ${index}`} value={user._id} style={{ textTransform: 'capitalize' }}>
										{user.fullName}
									</MenuItem>))
							}
						</Select>
						<FormHelperText id="my-helper-text">Please select atleast 1 author</FormHelperText>
					</FormControl>
				</MyPATDialog>
			</div>
		);
	}
}

const mapStateToProps = (state: any) => ({
	users: _.get(state, 'mylibraryData.users.list', []),
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	usersList
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ContentAuthorModal));
